// import { useRef, useEffect } from "react";
// import SectionHeading from "./SectionHeading";

// import "../../Assets/Css/normalize-5.0.0.min.css";
// import "../../Assets/Css/open-props.min.css";

// import trackImg1 from "../../Assets/Images/track-item1.png";
// import trackImg2 from "../../Assets/Images/track-item2.png";
// import trackImg3 from "../../Assets/Images/track-item3.png";
// // import trackImg4 from "../../Assets/Images/track-item4.png";
// // import trackImg5 from "../../Assets/Images/track-item5.png";
// // import trackImg6 from "../../Assets/Images/track-item6.png";
// // import trackImg7 from "../../Assets/Images/track-item7.png";
// // import trackImg8 from "../../Assets/Images/track-item8.png";
// // import trackImg9 from "../../Assets/Images/track-item9.png";
// // import trackImg10 from "../../Assets/Images/track-item10.png";
// // import trackImg11 from "../../Assets/Images/track-item11.png";
// // import trackImg12 from "../../Assets/Images/track-item12.png";
// // import trackImg13 from "../../Assets/Images/track-item13.png";
// // import trackImg14 from "../../Assets/Images/track-item14.png";
// import trackImg15 from "../../Assets/Images/track-item15.png";
// import trackImg16 from "../../Assets/Images/track-item16.png";




// // const imageUrls = [trackImg1, trackImg2, trackImg3, trackImg4, trackImg5, trackImg6, trackImg7, trackImg8, trackImg9, trackImg10, trackImg11, trackImg12, trackImg13, trackImg14];
// const imageUrls = [trackImg1, trackImg2, trackImg3, trackImg15, trackImg16];

// const HorizontalScroll = () => {
//   const trackRef = useRef(null);

//   useEffect(() => {
//     const track = trackRef.current;
//     let animationFrameId;
//     const scrollSpeed = 2;

//     const scroll = () => {
//       if (!track) return;

//       track.scrollLeft += scrollSpeed;

//       if (track.scrollLeft >= track.scrollWidth / 2) {
//         track.scrollLeft = track.scrollLeft - track.scrollWidth / 2;
//       }

//       animationFrameId = requestAnimationFrame(scroll);
//     };

//     animationFrameId = requestAnimationFrame(scroll);

//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   return (
//     <div className="track-wrapper ">

//       <ul className="track" ref={trackRef}>
//         {[...imageUrls, ...imageUrls].map((url, index) => (
//           <li className="track-item" key={index}>
//             <img
//               src={url}
//               alt={`Slide ${index + 1}`}

//             />
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// function HomeWork() {
//   return (
//     <div>
//       <SectionHeading
//         secTitle="Our Work"
//         secIndex="From Vision to Reality – Our Journey of Excellence"
//       />
//       <HorizontalScroll />
//     </div>
//   );
// }

// export default HomeWork;

import { useEffect, useRef, useState } from "react";
import SectionHeading from "./SectionHeading";
import axios from "../../axios";

import "../../Assets/Css/normalize-5.0.0.min.css";
import "../../Assets/Css/open-props.min.css";

function HomeWork() {
  const trackRef = useRef(null);
  const [ourWorkImages, setOurWorkImages] = useState([]);

  // Fetch data from backend
  useEffect(() => {
    axios.get("/our-work")
      .then(res => {
        const imageData = res.data.map(item => ({
          url: item.image_url,
          name: item.work_name,
        }));
        setOurWorkImages(imageData);
      })
      .catch(err => {
        console.error("Failed to load Our Work images", err);
      });
  }, []);

  // Auto-scroll logic
  useEffect(() => {
    const track = trackRef.current;
    let animationFrameId;
    const scrollSpeed = 3;

    const scroll = () => {
      if (!track) return;
      track.scrollLeft += scrollSpeed;

      if (track.scrollLeft >= track.scrollWidth / 2) {
        track.scrollLeft = track.scrollLeft - track.scrollWidth / 2;
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    if (ourWorkImages.length > 0) {
      animationFrameId = requestAnimationFrame(scroll);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, [ourWorkImages]);

  return (
    ourWorkImages.length > 0 && (
      <div>
        <SectionHeading
          secTitle="Our Work"
          secIndex="From Vision to Reality – Our Journey of Excellence"
        />

        <div className="track-wrapper">
          <ul className="track" ref={trackRef}>
            {[...ourWorkImages, ...ourWorkImages].map((item, index) => (
              <li className="track-item" key={index}>
                <img src={item.url} alt={item.name || `Work ${index + 1}`} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  );
}

export default HomeWork;
